import React, { PropsWithChildren, useEffect } from 'react';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

import useAuth from 'Modules/firebase/use-auth';
import LoadingPage from 'app/Pages/LoadingPage';
import Loader from 'Components/Loader';

const AuthzGuard: React.FC<PropsWithChildren> = ({ children }) => {
    const { loading, error } = useAuth();
    const navigate = useOrgNavigate();

    useEffect(() => {
        if (!loading && error) {
            navigate(`/access-denied?error=${error.message}`);
        }
    }, [navigate, loading, error]);

    if (loading) {
        return (
            <LoadingPage container>
                <Loader message="Checking for credentials" />
            </LoadingPage>
        );
    }

    return children;
};

export default AuthzGuard;
